import React from 'react';
import VerticalNav from 'components/v2/navs/VerticalNav';
import UserCircleIcon from 'components/v2/icons/UserCircleIcon';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

const Sidebar = ({ userId, activePage }) => {
  function isActive(page) {
    return activePage === page;
  }
  const { t } = useTranslation();

  const profileActive = isActive('profile');
  return (
    <VerticalNav>
      <VerticalNav.NavItemWithIcon
        url={`/users/${userId}`}
        active={profileActive}
        title={titleize(t('PROFILE', { count: 1 }))}
      >
        {(iconClassName) => (
          <UserCircleIcon size="medium" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
    </VerticalNav>
  );
};

Sidebar.propTypes = {
  userId: PropTypes.string,
  activePage: PropTypes.string,
};

Sidebar.defaultProps = {
  activePage: 'profile',
};

export default Sidebar;
